module.exports = __webpack_public_path__ + "static/media/IMG_2130.4ec26a80.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/IMG_2130.PNG
// module id = 448
// module chunks = 0